import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { isIPv4, isIPv6 } from 'is-ip';
import isCidr from 'is-cidr';

export const IpValidator: (errorMessage: string, allowIpV6?: boolean, allowCIDR?: boolean) => FormValidator = (
  errorMessage: string,
  allowIpV6 = true,
  allowCIDR = true
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (isIPv4(value) || (allowIpV6 && isIPv6(value))) {
      return { valid: true };
    }

    if (!allowCIDR) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    if (isCidr.v4(value) || (allowIpV6 && isCidr.v6(value))) {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
